import { type ForwardedRef, forwardRef, memo } from "react";

import { CartBase } from "@cart/CartBase";
import { tw } from "classnames";

type DataGiftNoteStatus = {
  giftButtonText: string;
  giftEditNote: string;
  giftText: string;
};

type Props = {
  btnAddLabel: string;
  btnCloseLabel: string;
  bundleValueText: string;
  cartDiscountTitle: string;
  cartLinkTo: string;
  cartProductGiftItemButtonEditTextLabel: string;
  cartProductGiftItemButtonTextLabel: string;
  cartProductPage: string;
  cartSpendingGiftButtonTextLabel: string;
  cartSpendingGiftTitleLabel: string;
  dataGiftNoteStatus: DataGiftNoteStatus;
  linkAriaLabel: string;
  subtotalLabel: string;
};

const styles = {
  cartDrawer: tw(
    "relative",
    "h-screen",
    "max-h-dynamic-screen",
    "w-screen",
    "bg-background-secondary",
    "md:w-sidebar"
  ),
};

const CartDrawerViewBase = (
  {
    btnAddLabel,
    btnCloseLabel,
    bundleValueText,
    cartDiscountTitle,
    cartLinkTo,
    cartProductGiftItemButtonEditTextLabel,
    cartProductGiftItemButtonTextLabel,
    cartProductPage,
    cartSpendingGiftButtonTextLabel,
    cartSpendingGiftTitleLabel,
    dataGiftNoteStatus,
    linkAriaLabel,
    subtotalLabel,
  }: Props,
  ref: ForwardedRef<HTMLDivElement>
) => {
  return (
    <div className={styles.cartDrawer} data-testid="cartDrawer" ref={ref}>
      <CartBase
        btnAddLabel={btnAddLabel}
        btnCloseLabel={btnCloseLabel}
        bundleValueText={bundleValueText}
        cartDiscountTitle={cartDiscountTitle}
        cartLinkTo={cartLinkTo}
        cartProductGiftItemButtonEditTextLabel={
          cartProductGiftItemButtonEditTextLabel
        }
        cartProductGiftItemButtonTextLabel={cartProductGiftItemButtonTextLabel}
        cartProductPage={cartProductPage}
        cartSpendingGiftButtonTextLabel={cartSpendingGiftButtonTextLabel}
        cartSpendingGiftTitleLabel={cartSpendingGiftTitleLabel}
        dataGiftNoteStatus={dataGiftNoteStatus}
        linkAriaLabel={linkAriaLabel}
        subtotalLabel={subtotalLabel}
      />
    </div>
  );
};

export const CartDrawerView = memo(forwardRef(CartDrawerViewBase));
